import FAQ1 from './Variants/FAQ1'
import FAQ2 from './Variants/FAQ2'
import FAQ3 from './Variants/FAQ3'
import FAQ4 from './Variants/FAQ4'

export const FAQ_VARIANTS = Object.freeze({
	VARIANT_1: 'faq-1',
	VARIANT_2: 'faq-2',
	VARIANT_3: 'faq-3',
	VARIANT_4: 'faq-4',
})

export const VARIANTS = Object.freeze({
	[FAQ_VARIANTS.VARIANT_1]: FAQ1,
	[FAQ_VARIANTS.VARIANT_2]: FAQ2,
	[FAQ_VARIANTS.VARIANT_3]: FAQ3,
	[FAQ_VARIANTS.VARIANT_4]: FAQ4,
})
